import { createRouter, createWebHistory } from 'vue-router'
import Start from '../views/viewStart.vue'

const routes = [
  { path: '/:pathMatch(.*)*', component: Start} //all
]

const router = createRouter({history: createWebHistory(process.env.BASE_URL),routes})
export default router
